import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IGetDetailsClaimResponse from 'services/httpClient/responses/claim/IGetDetailsClaimResponse';
import IGetDetailsInterventionResponse from 'services/httpClient/responses/intervention/IGetDetailsInterventionResponse';

import { interventionActions } from '../index';
import { IGetDetailsInterventionRequestAction } from '../reducers/getDetails/request';

function* getDetails(
  action: PayloadAction<IGetDetailsInterventionRequestAction>,
) {
  try {
    const interventionResponse: AxiosResponse<IGetDetailsInterventionResponse> =
      yield call(rikHttpClient.get, `interventions/${action.payload.data.id}`);

    const claimResponse: AxiosResponse<IGetDetailsClaimResponse> = yield call(
      rikHttpClient.get,
      `claims/${interventionResponse.data.claim_id}`,
    );

    yield put(
      interventionActions.getDetailsSuccess({
        intervention: interventionResponse.data,
        claim: claimResponse.data,
      }),
    );

    if (action.payload.functions.replace) {
      action.payload.functions.replace(interventionResponse.data.trader_id);
    }
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(interventionActions.getDetailsFailure());
  }
}

export default getDetails;
